<div
    class="relative grow overflow-y-auto"
    [ngClass]="{ 'blur-[2px] pointer-events-none [&_*]:select-none': loading() }"
>
    @if (loading()) {
        <div
            class="absolute flex left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 justify-center items-center z-50"
        >
            <mat-spinner [diameter]="32"></mat-spinner>
        </div>
    }

    @if (benefit.error()) {
        <div class="p-4 text-red-500">Benefit nije pronađen.</div>
    }

    @if (loaded()) {
        <div class="flex flex-col gap-4 bg-valamargray border-2 static p-4">
            <button class="flex valben-button text-lg ml-auto" (click)="save()" [disabled]="!employeesReady()">
                Spremi
            </button>

            <valben-dictionary-input
                [formField]="benefitForm.names"
                title="Naziv"
            ></valben-dictionary-input>

            <valben-dictionary-input
                [formField]="benefitForm.descriptions"
                [textArea]="true"
                [richText]="true"
                title="Opis"
            ></valben-dictionary-input>

            <valben-boolean-input
                [formField]="benefitForm.isActive"
                title="Aktivan"
            ></valben-boolean-input>

            <valben-boolean-input
                [formField]="benefitForm.isDraft"
                title="Skica"
            ></valben-boolean-input>

            <valben-file-input
                [formField]="benefitForm.image"
                title="Prenesi sliku ili direktni url postojeće slike"
                fileType="image/*"
            ></valben-file-input>

            <valben-categories-input
                [formField]="benefitForm.categoryIds"
                [type]="categoriesType"
                title="Kategorije"
            ></valben-categories-input>

            <valben-filters [(value)]="filters" />

            <div class="flex gap-4 justify-end items-center select-none">
                <button class="valben-button text-lg" (click)="back()">Natrag</button>
                <button class="valben-button text-lg" (click)="showDeleteModal()">Obriši</button>
                <button class="valben-button text-lg" (click)="save()" [disabled]="!employeesReady()">Spremi</button>
            </div>
        </div>
    }
</div>
